<template>
    <EndOfJob></EndOfJob>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const EndOfJob = defineAsyncComponent(() =>
    import("../../components/Assembly/EndOfJob/EndOfJob.vue")
);

export default {
    name: "EndOfJob_Component", //The name you are in should not equal the name of the component you are importing.
    components: { EndOfJob, AuthLayout },
};
</script>
